<template>
  <div class="activate-table-button-component">
    <button v-if="text" :class="['bg-transparent border border-black font-semibold! px-4 py-1.5 rounded-full text-sm hover:bg-[#F4F9FF] hover:text-[#23569F] hover:border-[#23569F]', stylingClasses]" @click="onClick">{{ text }}</button>
  </div>
</template>

<script src="./table-column-button.js"></script>
<style scoped lang="scss">
@reference '#tailwind.scss';
.activate-table-button-component {
  button {
    @media (max-width: 1400px) {
      @apply text-xs! px-2! py-1!;
    }
  }
}
</style>
